<template>
  <div style="padding-top:44px;height:calc(100vh - 145px)">
    <h3 class="title">统计</h3>
    <div class="order-list tt-custom-tab" style="padding:0 65px 0 30px;">
      <div style="display: flex;justify-content: space-between;color:#666;margin-bottom:20px;">
        <div>
          <label>统计周期</label>
          <label>{{ form.start_date+' 至 '+ form.end_date}}</label>
        </div>
        <div style="display:flex;justify-content: center;">
          <div class="article-tabName" :class="{'selected':dateType==tab.value}" v-for="(tab,index) in tabs" @click="changeDateType(tab.value)">
            {{ tab.name }}
          </div>
        </div>
      </div>
      <div style="display: flex;flex-wrap: wrap;">
        <div v-for="(item,index) in cards" :key="index" class="data-card">
          <p class="name">{{ item.name }}</p>
          <div class="number">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import Mail from './MailBody.vue'
import api from '../../services/api.js'
import { API_HOST } from '../../services/constant.js'

export default {
  name: 'OrderList',
  data() {
    return {   
      API_HOST:API_HOST,
      dateType:1,
      tabs:[
        {
          name:'近7日',
          value:1
        },
        {
          name:'近30日',
          value:2
        }
      ],
      form:{
        start_date:'',
        end_date:''
      },
      cards:[]
    }
  },
  mounted() {
    let today = new Date();
    this.form.end_date = this.formatDate(today);
    this.form.start_date = this.formatDate(new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000))
    this.getTongji()
  },
  methods: {
    changeDateType(type){
      this.dateType = type;
      let today = new Date();
      switch(this.dateType){
        case 1:
          this.form.start_date =  this.formatDate(new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000));
          break;
        case 2:
          this.form.start_date =  this.formatDate(new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000));
          break;
      }
      this.getTongji()
    },
    formatDate(d){
      let year = d.getFullYear().toString();
      let month = (d.getMonth()+1)<10?'0'+(d.getMonth()+1).toString():(d.getMonth()+1).toString();
      let day = d.getDate()<10?'0'+d.getDate().toString():d.getDate().toString();
      //let hour = d.getHours().toString();
      //let min = d.getMinutes().toString();
      return year+'-'+month+'-'+day;
    },
    async getTongji(){
      this.loadingEdit=true;
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_account_daily_stat_post',
        params: this.form
      })
      res = res.body
      if (res.status == 'ok') {
        let data = res.result;
        for(let p in data){
          let o = { name:p,value:data[p] }
          this.cards.push(o)
        }
        //this.generateContent(this.detail.content);
      }
    },
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .article-tabName{
    color:#666;
    font-size: 16px;
    height:40px;
    line-height: 40px;
    padding:0 16px;
    cursor: pointer;
  }
  .article-tabName.selected{
    background:rgba(0,0,0,0.03);   
    font-weight: bold;
    color:#333;
    border-radius: 3px;
  }
  .data-card{
    width:150px;
    padding: 12px 10px 12px 0px;
    .name{
      color: #666;
      font-size: 14px;
      line-height: 22px;
    }
    .number{
      margin: 4px 0;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
  }
  .title{
    height: 20px;
    font-size: 18px;
    color: #333;
    line-height: 20px;
    text-align: center;
    margin-bottom: 35px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/articles/Tongji.vue